import {
  AgxColumn,
  AgxLabel,
  AgxRow,
  AgxPriceRange,
} from '@urbanx/agx-ui-components';
import { PriceOpinion } from './types';

interface PriceOpinionProps {
  id: string;
  onValueChanged: (change: { id: string; value: PriceOpinion }) => void;
  label?: string;
  defaultValue?: PriceOpinion;
  maxPriceRangePercent?: number;
}

const PriceOpinionComponent = (props: PriceOpinionProps) => {
  const {
    id,
    label,
    onValueChanged,
    defaultValue = null,
    maxPriceRangePercent,
  } = props;

  return (
    <AgxColumn fill veryLargeGap>
      <AgxRow fill spaceBetween>
        <AgxLabel large>{label}</AgxLabel>
      </AgxRow>
      <AgxPriceRange
        id={id}
        label="Property and improvements"
        onValueChanged={change => {
          onValueChanged({
            id,
            value: {
              ...defaultValue,
              propertyAndImprovements: {
                ...change,
              },
            },
          });
        }}
        defaultValue={defaultValue?.propertyAndImprovements}
        defaultUpperRangeSelected={true}
        maxPriceRangePercent={maxPriceRangePercent}
      />
    </AgxColumn>
  );
};

export default PriceOpinionComponent;
